import { useEffect } from "react";
import "./style/Terms.css";

export default function Terms() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.id = "termly-jssdk";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="terms-container">
      <div
        name="termly-embed"
        data-id="36bc4c5d-935f-4078-8d72-582079fc7a63"
      ></div>
    </div>
  );
}
